import React from "react";
import { useSelector } from "react-redux";
import { selectCurrentSpaceId } from "slices/spaceSlice";
import VideoBar from "./VideoBar/VideoBar";

const VideoBarContainer = () => {
  const currentSpaceId = useSelector(selectCurrentSpaceId);
  if (currentSpaceId) {
    return <VideoBar />;
  } else return null;
};
export default VideoBarContainer;
